"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Client = {
  edit: false,
  hash: '',
  serviceHash: '',
  currentDate: new Date(),
  type: undefined,
  typeID: undefined,
  serviceID: undefined,
  typedInstance: undefined,
  aiSuggestedPrice: 0,
  specialDealMethod: 1,
  specialDealCountry: '',
  specialDealTaskHash: '',
  specialDealOfferHash: '',
  userCountryCode: 'en',
  spAiText: '',
  onload: document.addEventListener('DOMContentLoaded', function () {
    Client.init();
  }),
  init: function init() {
    this.bind();
    this.initDateTimePicker();
    this.checkedSowBlock();
    this.showPopUp();
    this.aiLine();
    this.generateMapWithRoutesForTaskDetailsPage();
    // this.checkedBlockBookingMethod();

    Autocomplete.googleAutocompleteForClient.autocompleteField();
  },
  bind: function bind() {
    $(document).on('click', '.open-subscription-info-popup', function (event) {
      event.preventDefault();
      Client.ajax.checkSubscription($(this).attr('data-hash'));
    }).on('click', '.unmasked-offers--close', function (event) {
      event.preventDefault();
      $('.unmasked-offers--popup').remove();
    }).on('click', '.unmasked-offers--close', function (event) {
      event.preventDefault();
      $('.unmasked-offers--popup').remove();
    }).on('click', '.related-categories--block ', function (event) {
      $('.checkbox').on('change', function () {
        var parentBlock = $(this).closest('.related-categories--block');
        var textarea = parentBlock.find('textarea');
        textarea.toggle($(this).is(':checked'));
        if (!$(this).is(':checked')) parentBlock.find('.error').hide();
        Client.updateRelatedCategoriesData();
      });
      $('textarea').on('change', function () {
        var textarea = $(this).closest('.related-categories--block').find('textarea');
        Client.updateRelatedCategoriesData();
      });
    }).on('click', 'a.open-propose-register-service-popup', function (event) {
      event.preventDefault();
      $('#need-register-service').addClass('active');
    }).on('click', 'a.open-blocked-make-offers-action-popup', function (event) {
      event.preventDefault();
      $('#blocked-make-offers-popup').addClass('active');
    }).on('click', 'button.choose-task-direction', function (event) {
      event.preventDefault();
      var type = $(this).attr('data-type');
      var typeID = $(this).attr('data-type-id');
      var text = $(this).attr('data-text');
      Client.type = type;
      Client.typeID = typeID;
      Client.text = text.trim();
      Client.ajax.chooseDirection();
    }).on('click', 'button.back-to-choose-direction-page', function (event) {
      event.preventDefault();
      Client.serviceID = undefined;
      Client.ajax.backToChooseDirectionPage();
    }).on('click', 'button.back-to-choose-service-page', function (event) {
      event.preventDefault();
      Client.ajax.backToChooseServicePage();
    }).on('click', '.client-service-checkbox', function () {
      $('.post-task-choose__item').removeClass('active');
      if ($(this).is(':checked')) {
        $('.selected-service').prop('disabled', false);
        Client.serviceID = $(this).val();
        $(this).closest('.post-task-choose__item').addClass('active');
        Client.ajax.fetchFirstClientFormStep();
      } else {
        $('.selected-service').prop('disabled', true);
        Client.serviceID = undefined;
      }
    }).on('change', '.select-check-value', function () {
      Client.checkedSelect($(this));
    }).on('change', 'input[name="client_when_type"]', function () {
      Client.ajax.fetchBlockWhen($(this).val());
    }).on('click', '.form-step__add-date', function (event) {
      event.preventDefault();
      Client.ajax.addAdditionalDateTimeBlock();
    }).on('click', '.form-step__remove-date', function (event) {
      event.preventDefault();
      if ($('div.block-when-dates').length !== 1) {
        $(this).closest('.block-when-dates').remove();
      }
      if ($('div.block-when-dates').length === 1) {
        $('div.block-when-dates').first().find('.form-step__remove-date').hide();
      }
      Client.checkAddRemoveDateButtons();
    }).on('click', '.block-when-hour-start', function (event) {
      event.preventDefault();
      $(this).closest('.block-when-dates').find('.block-when-hour-finish').val('');
    }).on('change', '.block-when-dates', function (event) {
      event.preventDefault();
      if ($(this).find('.block-when-date').val().length > 0) {
        $(this).find('.block-when-date').parent().removeClass('error');
      }
      if ($(this).find('.block-when-hour-start').val().length > 0) {
        $(this).find('.block-when-hour-start').parent().removeClass('error');
      }
      if ($(this).find('.block-when-hour-finish').val().length > 0) {
        $(this).find('.block-when-hour-finish').parent().removeClass('error');
      }
    }).on('change', '.block-when-date', function (event) {
      event.preventDefault();
      var parentBlock = $(this).closest('.block-when-dates');
      parentBlock.find('.block-when-hour-start').val('');
      parentBlock.find('.block-when-hour-finish').val('');
    }).on('change', '#select-task-type', function (event) {
      if (parseInt($(this).val()) === 1) {
        $('#driver-task-services').show();
        $('#driver-task-services').find('.search-service-checkbox').prop('checked', true);
        $('#indoor-task-services').hide();
        $('#indoor-task-services').find('.search-service-checkbox').prop('checked', false);
        $('#outdoor-task-services').hide();
        $('#outdoor-task-services').find('.search-service-checkbox').prop('checked', false);
        $('#travel-task-services').hide();
        $('#travel-task-services').find('.search-service-checkbox').prop('checked', false);
      } else if (parseInt($(this).val()) === 4) {
        $('#driver-task-services').hide();
        $('#driver-task-services').find('.search-service-checkbox').prop('checked', false);
        $('#indoor-task-services').show();
        $('#indoor-task-services').find('.search-service-checkbox').prop('checked', true);
        $('#outdoor-task-services').show();
        $('#outdoor-task-services').find('.search-service-checkbox').prop('checked', true);
        $('#travel-task-services').hide();
        $('#travel-task-services').find('.search-service-checkbox').prop('checked', false);
      } else if (parseInt($(this).val()) === 5) {
        $('#driver-task-services').hide();
        $('#driver-task-services').find('.search-service-checkbox').prop('checked', false);
        $('#indoor-task-services').hide();
        $('#indoor-task-services').find('.search-service-checkbox').prop('checked', false);
        $('#outdoor-task-services').hide();
        $('#outdoor-task-services').find('.search-service-checkbox').prop('checked', false);
        $('#travel-task-services').show();
        $('#travel-task-services').find('.search-service-checkbox').prop('checked', true);
      } else {
        $('#driver-task-services').show();
        $('#driver-task-services').find('.search-service-checkbox').prop('checked', true);
        $('#indoor-task-services').show();
        $('#indoor-task-services').find('.search-service-checkbox').prop('checked', true);
        $('#outdoor-task-services').show();
        $('#outdoor-task-services').find('.search-service-checkbox').prop('checked', true);
        $('#travel-task-services').show();
        $('#travel-task-services').find('.search-service-checkbox').prop('checked', false);
      }
      Driver.setSelectString($('.select-transports__pop-up'));
    }).on('change', '[name="client_budget_variant"]', function (event) {
      event.preventDefault();
      var title = $(this).attr('data-title');
      $('label[for="client_budget"]').text(title);
      var field = $('input#client_budget');
      if ($('[name="client_budget_variant"]:checked').val() === '1') {
        field.attr('placeholder', field.attr('data-fixed'));
        $('.price-serv__input').addClass('budget-fixed').removeClass('budget-per-hour');
      } else {
        field.attr('placeholder', field.attr('data-hour'));
        $('.price-serv__input').addClass('budget-per-hour').removeClass('budget-fixed');
      }
    }).on('input paste change', 'input#client_budget', function () {
      var hours = 1;
      if ($('#price-per-hour').is(':checked')) {
        hours = parseInt($('[name="make_offer_amount_per_hour"]').val());
      }
      Client.calculateBudget(parseFloat($(this).val().trim()), hours);
    }).on('click', 'button.open-offer-reject-popup', function (event) {
      event.preventDefault();
      $('.popup-bg-opacity--chat').hide();
      $('.offer-details-popup').hide();
      $('#reject-offer').attr('data-offer', $(this).attr('data-offer'));
      setTimeout(function () {
        $('#reject-offer-popup').show();
      }, 100);
    }).on('click', '#reject-offer', function (event) {
      event.preventDefault();
      Client.ajax.rejectOffer($(this).attr('data-offer'), $(this).closest('form').find('textarea').val());
    }).on('click', 'button.open-withdraw-edit-popup', function (event) {
      event.preventDefault();
      $('#block-withdraw-edit-choose').show();
      $('#block-withdraw-confirm').hide();
      $('#withdraw-offer').attr('data-offer', $(this).attr('data-offer'));
      $('#popup-link-edit-offer').attr('href', $(this).attr('data-url'));
      setTimeout(function () {
        $('#withdraw-edit-popup').show();
      }, 100);
    }).on('click', '#open-withdraw-offer-block', function (event) {
      event.preventDefault();
      $('#block-withdraw-edit-choose').hide();
      $('#block-withdraw-confirm').show();
    }).on('click', 'button#withdraw-offer', function (event) {
      event.preventDefault();
      var reason = $(this).closest('form.pop-up-tasks__wrapper').find('textarea').val();
      Client.ajax.withdrawOfferAsServiceProvider($(this).attr('data-offer'), reason);
    }).on('click', 'button.open-edit-task-popup', function (event) {
      event.preventDefault();
      $('#block-cancel-edit-choose').show();
      $('#block-cancel-edit-confirm').hide();
      $('#cancel-task').attr('data-task', $(this).attr('data-id'));
      $('#popup-link-edit-task').attr('href', $(this).attr('data-url'));
      setTimeout(function () {
        $('#edit-cancel-task-popup').show();
      }, 100);
    }).on('click', '#open-cancel-task-block', function (event) {
      event.preventDefault();
      $('#block-cancel-edit-choose').hide();
      $('#block-cancel-edit-confirm').show();
    }).on('click', 'button#cancel-task', function (event) {
      event.preventDefault();
      var reasonField = $(this).closest('.pop-up-tasks__wrapper').find('#cancel-task-reason');
      if (reasonField.val().length >= 10) {
        Client.ajax.deleteTask($(this).attr('data-task'), true, reasonField.val());
      } else {
        reasonField.next().show();
        setTimeout(function () {
          reasonField.next().hide();
        }, 1500);
      }
    }).on('click', 'button.open-delete-task-popup', function (event) {
      event.preventDefault();
      var deleteTaskBtn = $('#delete-task');
      var block = $(this).closest('.my-task__item');
      if (!block.length) {
        block = $(this).closest('.card-new__item');
      }
      var taskHash = block.attr('id');
      deleteTaskBtn.attr('data-task');
      deleteTaskBtn.attr('data-task', taskHash);
      setTimeout(function () {
        $('#delete-task-popup').show();
      }, 100);
    }).on('click', '#delete-task', function (event) {
      event.preventDefault();
      var reasonField = $(this).closest('.pop-up-tasks__wrapper').find('#cancel-task-reason');
      if (reasonField.val().length >= 10) {
        Client.ajax.deleteTask($(this).attr('data-task'), false, reasonField.val());
      } else {
        reasonField.next().show();
        setTimeout(function () {
          reasonField.next().hide();
        }, 1500);
      }
    }).on('click', '.open-offer-details', function (event) {
      event.preventDefault();
      Client.ajax.openOfferDetailsPopup($(this).closest('.offer-info-item').attr('id'));
    }).on('change', 'select[name="make_offer_amount_per_hour"]', function (event) {
      event.preventDefault();
      var type = $(this).attr('data-type');
      if (type === "0") {
        Client.calculateBudget(parseFloat($(this).closest('div.price-input__price-per-hour').find('[name="make_offer_amount"]').val().trim()), parseInt($(this).val()));
      } else if (type === "1") {
        Client.ajax.changeBookingHours($(this).val());
      }
    }).on('input', 'input#booking-amount', function () {
      var amount = parseFloat($(this).val());
      if (!isNaN(amount)) {
        $(this).val(amount);
        Client.ajax.changeBookingAmount(amount);
      } else {
        $('#service_provider_fees').text(0);
        $('.service_provider_fees').val(0);
        $('#platform_fees').text(0);
        $('#total_price').text(0);
      }
    }).on('change', 'select#booking-hours', function () {
      Client.ajax.changeBookingHours($(this).val());
    }).on('click', 'button.open-approve-offer-popup', function (event) {
      event.preventDefault();
      // after the deploy - need to clean (old cards)
      var block = $(this).closest('.my-task__item');
      if (!block.length) {
        block = $(this).closest('.card-new__item');
      }
      Client.ajax.fetchApproveOfferPopup(block.attr('data-offer-hash'), block.attr('data-type'));
      setTimeout(function () {
        $('#approve-popup').show();
      }, 100);
    }).on('click', '#approve-offer', function (event) {
      event.preventDefault();
      Main.showPreloader($(this));
      Client.ajax.approveOffer($(this), $(this).attr('data-offer-hash'), $(this).attr('data-type'));
    }).on('click', '.open-offer-cancel-popup-as-service-provider', function (event) {
      event.preventDefault();
      var block = $(this).closest('.my-task__item');
      if (!block.length) {
        block = $(this).closest('.card-new__item');
      }
      Client.hash = block.attr('data-offer-hash');
      Client.type = block.attr('data-type');
      setTimeout(function () {
        $('#cancel-offer-as-service-provider').show();
      }, 100);
    }).on('click', '.open-offer-cancel-popup-as-client', function (event) {
      event.preventDefault();
      var block = $(this).closest('.my-task__item');
      if (!block.length) {
        block = $(this).closest('.card-new__item');
      }
      var nonRefundableAmount = block.find('input[name="nonRefundableAmount"]').val();
      Client.hash = block.attr('data-offer-hash');
      Client.type = block.attr('data-type');
      $('.non-refundable-amount-text').html('');
      setTimeout(function () {
        var text = $('.non-refundable-amount-text').attr('data-text');
        $('.non-refundable-amount-text').html(text.replace('nonRefundableAmount', nonRefundableAmount));
        $('#cancel-offer-as-client').show();
      }, 100);
    }).on('click', '.open-sos-popup', function (event) {
      event.preventDefault();
      setTimeout(function () {
        $('#sos-popup').show();
      }, 100);
    }).on('change', 'select.reason_of_cancellation', function (event) {}).on('click', 'input[name="offer_agree_policy"]', function () {
      if ($(this).is(':checked')) {
        $(this).val('1');
      } else {
        $(this).val('0');
      }
    }).on('click', '.cancel-offer-as-service-provider', function (event) {
      event.preventDefault();
      Main.showPreloader($(this));
      Client.ajax.cancelOfferAsServiceProvider($(this));
    }).on('click', '.cancel-offer-as-client', function (event) {
      event.preventDefault();
      Main.showPreloader($(this));
      Client.ajax.cancelOfferAsClient($(this));
    }).on('click', '.pop-up-tasks--next', function (event) {
      event.preventDefault();
      $('.pop-up-tasks--step-one').hide();
      $('.pop-up-tasks--step-two').show();
    }).on('click', '.close-popup', function (event) {
      event.preventDefault();
      $('.pop-up-tasks--step-one').show();
      $('.pop-up-tasks--step-two').hide();
    }).on('click', '.mark-completed-as-client', function (event) {
      event.preventDefault();
      Main.showPreloader($(this));
      var block = $(this).closest('.my-task__item');
      if (!block.length) {
        block = $(this).closest('.card-new__item');
      }
      Client.ajax.markCompletedAsClient($(this), block.attr('data-offer-hash'), block.attr('data-type'));
    }).on('click', '.mark-completed-as-service-provider', function (event) {
      event.preventDefault();
      Main.showPreloader($(this));
      var block = $(this).closest('.my-task__item');
      if (!block.length) {
        block = $(this).closest('.card-new__item');
      }
      Client.ajax.markCompletedAsServiceProvider($(this), block.attr('data-offer-hash'), block.attr('data-type'));
    }).on('click', '.open-offer-review-popup', function (event) {
      event.preventDefault();
      // after the deploy - need to clean (old cards)
      var block = $(this).closest('.my-task__item');
      if (!block.length) {
        block = $(this).closest('.card-new__item');
      }
      Client.ajax.openReview(block.attr('data-offer-hash'));
    }).on('click', '.open-extend-task-popup', function (event) {
      event.preventDefault();
      Main.showPreloader($(this));
      var block = $(this).closest('.my-task__item');
      if (!block.length) {
        block = $(this).closest('.card-new__item');
      }
      Client.ajax.openExtendOfferPopup($(this), block.attr('data-offer-hash'));
    }).on('click', '.reject-extend-offer', function (event) {
      event.preventDefault();
      Main.showPreloader($(this));
      Client.ajax.rejectExtendOffer($(this), $(this).closest('.pop-up-service__inner').attr('id'));
    }).on('click', '.pop-up-service__details', function (event) {
      event.preventDefault();
      $(this).toggleClass('active');
      $(this).closest('.pop-up-service__inner').find('.pop-up-service__desc').slideToggle();
    }).on('click', '.open-decline-offer-popup', function (event) {
      event.preventDefault();
      var block = $(this).closest('.my-task__item');
      if (!block.length) {
        block = $(this).closest('.card-new__item');
      }
      $('input[name="offer_hash"]').val(block.attr('data-offer-hash'));
      setTimeout(function () {
        $('#decline-popup').show();
      }, 100);
    }).on('click', '.cannot-edit-task-tooltip', function (event) {
      event.preventDefault();
    }).on('mouseout', '.offers__desc', function (event) {
      $(this).find('.checked-tooltips').hide();
    }).on('click', '.download-offer-details', function (event) {
      event.preventDefault();
      Main.showPreloader($(this));
      $('.download-offer-popup').find('.submit-form').attr('data-hash', '');
      Client.ajax.downloadOfferDetails($(this), $(this).closest('.offer-info-item').attr('id'));
    }).on('change', '[name="make_offer_payout_option"]', function (event) {
      event.preventDefault();
      var selectedInput = $('[name="make_offer_payout_option"]:checked');
      var infoBlock = $(this).closest('div.how-want-to-get-paid').find('.how-want-to-get-paid-info');
      infoBlock.addClass('d-none');
      infoBlock.find('p').addClass('d-none');
      if (parseInt(selectedInput.val()) > 0) {
        infoBlock.removeClass('d-none');
        infoBlock.find("p[data-id=\"".concat(selectedInput.attr('id'), "\"]")).removeClass('d-none');
      }
    }).on('click', '.another-task--popup--close', function (event) {
      event.preventDefault();
      $(".another-task--popup").removeClass('active');
    }).on('click', '.unmasked-offers--item .details, .unmasked-offers--item .hide-details', function (event) {
      event.preventDefault();
      var parentBlock = $(this).closest('.unmasked-offers--item');
      parentBlock.find('.details').toggle();
      parentBlock.find('.hide-details').toggle();
      parentBlock.find('.block--details').toggleClass('active');
    });
    $(document).on('click', '#find-task-search-reset-address', function (e) {
      e.preventDefault();
      $('#driverInputSearch').val('');
      $('#city').val('');
      $('#lat').val('');
      $('#lng').val('');
      $('#find-task-search-btn').click();
    }).on('click', '#find-task-search-reset-radius', function (e) {
      e.preventDefault();
      $('[name="radius"]').val(0);
      $('#find-task-search-btn').click();
    }).on('click', '#find-task-search-reset-type', function (e) {
      e.preventDefault();
      $('#select-task-type').val(0);
      $('#find-task-search-btn').click();
    });
    $(document).on('click', '.open-payments-plan-popup', function (e) {
      e.preventDefault();
      if ($(this).text() == 'Selected') {
        $('.view-all-offers').prop('disabled', true);
        $(this).text('Choose plan');
        Payment.selectedPlan = 0;
      } else {
        $('.view-all-offers').prop('disabled', false);
        $('.open-payments-plan-popup').text('Choose plan');
        $(this).text('Selected');
        Payment.selectedPlan = $(this).attr('data-type');
      }
    }).on('click', '.view-all-offers', function (e) {
      e.preventDefault();
      var block = $(".open-payments-plan-popup[data-type=\"".concat(Payment.selectedPlan, "\"]"));
      var autoRenew = parseInt(block.attr('data-type')) === 1 ? 0 : block.closest('.choose-plan--popup-card').find('.switch').is(':checked') ? 1 : 0;
      var plan = block.attr('data-type');
      var pMethod = 1;
      var amount = block.attr('data-amount');
      var count = parseInt(block.attr('data-type')) === 1 ? $('.counter-data').text().trim() : 0;
      Main.showPreloader($(this));
      Client.ajax.openPaymentPlanBlockPopup($(this), autoRenew, plan, pMethod, amount, count);
    }).on('click', '.confirm-open-offers--btn', function (event) {
      var hash = $(this).attr('data-hash');
      $('.confirm-open-offers--popup').removeClass('active');
      Client.ajax.getOpenOffers(hash);
    }).on('click', '.confirm-open-offers--btn-close', function (event) {
      $('.confirm-open-offers--popup').removeClass('active');
    }).on('click', '.choose-plan--popup__close', function (event) {
      $('.choose-plan--popup').removeClass('active');
    });

    // .on('click', '.view-all-offers-1', function(event) {
    //         event.preventDefault();
    //
    //         let taskHash = $('.choose-plan--popup').attr('data-hash');
    //
    //         Main.showPreloader($('.view-all-offers'));
    //         Client.ajax.getOpenOffers(taskHash);
    //     })

    // Booking steps
    $(document).on('click', '#choose-travel-direction', function (e) {
      e.preventDefault();
      var hash = $(this).attr('data-hash');
      var type = $('[name="choose-travel-direction"]:checked').val();
      Client.ajax.renderBookingForm(hash, type);
      // }).on('change', '#open-to-offers', function (e) {
      //     e.preventDefault();
      //
      //     if ($(this).is(':checked')) {
      //         $('.open-to-offers-hide').slideUp(Main.animationParams);
      //
      //         setTimeout(function () {
      //             $('[name="client_budget"]').val(1);
      //         }, 500);
      //     } else {
      //         $('.open-to-offers-hide').slideDown(Main.animationParams);
      //
      //         $('[name="client_budget"]').val('');
      //         $('#platform_fees_taxes').text('-');
      //         $('#total_price').text('-');
      //     }
    }).on('change', '[name="post_task_budget_radio_buttons"]', function (e) {
      e.preventDefault();
      Client.manageRadioBudgetTypes();
    }).on('change', '.switch-task-view-status', function (event) {
      event.preventDefault();
      var closestBlock = $(this).closest('div.my-task__checked');
      var privateText = closestBlock.find('.my-task__private');
      var privateIcon = closestBlock.find('.my-task__private-icon');
      var privatePopup = closestBlock.find('.pop-up-private');
      var publicText = closestBlock.find('.my-task__public');
      var publicIcon = closestBlock.find('.my-task__public-icon');
      var publicPopup = closestBlock.find('.pop-up-public');
      if ($(this).is(':checked')) {
        Client.ajax.addPublicTaskStatus($(this).closest('.my-task__item').attr('id'));
        privateText.hide();
        privateIcon.hide();
        publicText.css('display', 'flex');
        publicIcon.css('display', 'flex');
        publicPopup.css('display', 'flex');
        setTimeout(function () {
          publicPopup.hide();
        }, 4000);
      } else {
        // after the deploy - need to clean (old cards)
        var block = $(this).closest('.my-task__item');
        if (!block.length) {
          block = $(this).closest('.card-new__item');
        }
        Client.ajax.addPrivateTaskStatus(block.attr('id'));
        privateText.css('display', 'flex');
        privateIcon.css('display', 'flex');
        privatePopup.css('display', 'flex');
        publicText.hide();
        publicIcon.hide();
        setTimeout(function () {
          privatePopup.hide();
        }, 4000);
      }
    }).keyup(function (event) {
      if (event.keyCode == 13) {}
    }).on('keydown', 'form.chat__send', function (event) {
      if (event.keyCode === 13 && event.shiftKey) {
        if ($('#send-message').length) {
          $("#send-message").click();
        }
      }
    }).on('click', '.close-find-task-option-popup', function (event) {
      // event.preventDefault();
      $('.find-task-option-popup').removeClass('active');
      Client.ajax.closeFindTaskOptionPopup();
    }).on('click', '.switch-find-task-option-popup', function (event) {
      event.preventDefault();
      var step = $(this).attr('data-step');
      if (parseInt(step) === 3) {
        Autocomplete.googleAutocompleteForClient.autocompleteField();
      }
      $('.find-task-option-popup').removeClass('active');
      $(".find-task-option-popup[data-step=\"".concat(step, "\"]")).addClass('active');
    }).on('change', '.find-task-options-country-checkbox, .find-task-options-type-checkbox', function (event) {
      event.preventDefault();
      $(this).closest('div[data-step]').find('button').prop('disabled', false);
    }).on('click', '[name="find-task-options-country-checkbox"], [name="find-task-options-type-checkbox"]', function (event) {
      // event.preventDefault();
      $(this).closest('div[data-step]').find('button').prop('disabled', false);
    }).on('click', '#save-find-task-options', function (event) {
      var _$$val;
      event.preventDefault();
      var country = $('[name="find-task-options-country-checkbox"]:checked').val();
      var type = $('[name="find-task-options-type-checkbox"]:checked').val();
      var city = (_$$val = $('[name="find-task-options-city"]').val()) !== null && _$$val !== void 0 ? _$$val : '';
      var location = $('[name="find-task-options-location"]').val();
      var lat = $('[name="find-task-options-lat"]').val();
      var lng = $('[name="find-task-options-lng"]').val();
      var radius = $('[name="find-task-options-radius"]').val();
      Client.ajax.saveFindTaskOptions(country, city, type, location, lat, lng, radius);
    }).on('click', '#find-task-options-location-data', function (event) {
      var button = $(this).closest('div[data-step]').find('button.button-red');
      button.prop('disabled', false);
      $('[name="find-task-options-location"]').val('');
      $('[name="find-task-options-lat"]').val('');
      $('[name="find-task-options-lng"]').val('');
    }).on('change blur', '.find-task-options-location-data', function (event) {
      var button = $(this).closest('div[data-step]').find('button.button-red');
      button.prop('disabled', true);
      setTimeout(function () {
        var location = $('[name="find-task-options-location"]').val();
        var lat = $('[name="find-task-options-lat"]').val();
        var lng = $('[name="find-task-options-lng"]').val();
        var radius = $('[name="find-task-options-radius"]').val();

        // console.log('location ', location);
        // console.log('location length ', location.length);
        // console.log('lat ', lat);
        // console.log('lat length ', lat.length);
        // console.log('lng ', lng);
        // console.log('lng length ', lng.length);
        // console.log('radius ', radius);
        // console.log('radius length ', radius.length);
        // console.log(location.length === 0 && lat.length === 0 && lng.length === 0 && radius.length === 0);

        if (location.length > 0 && lat.length > 0 && lng.length > 0 && radius.length > 0) {
          button.prop('disabled', false);
        }
      }, 750);
    }).on('change', '[name="do_you_want_travel"]', function (event) {
      if ($(this).val() == 1) {
        $('.travel-option').css('display', 'flex');
      } else {
        $('.travel-option').hide();
      }
    }).on('change', '[name="do_you_want_storage"]', function (event) {
      if ($(this).val() == 1) {
        $('.storage-option').css('display', 'flex');
      } else {
        $('.storage-option').hide();
      }
    }).on('change input paste blur', '.related-categories--block textarea', function (event) {
      $(this).closest('.related-categories--block').find('.error').hide();
    }).on('click', '.booking-service__generate-button', function (event) {
      event.preventDefault();
      var textarea = $('#make_offer_message');
      var taskID = $(this).attr('data-id');
      Main.showPreloader($(this));
      $('.booking-service__clear').hide();
      Client.ajax.generateAiSpComment($(this), textarea, taskID);
    }).on('click', '.booking-service__clear', function (event) {
      event.preventDefault();
      // if (Client.typedInstance) Client.typedInstance.destroy();
      $('#make_offer_message').val('');
      // Client.typedInstance = new Typed('#make_offer_message', {
      //     strings: [''],
      //     typeSpeed: 0,
      //     startDelay: 0,
      //     showCursor: false,
      //     onComplete: function () {
      //         $('.booking-service__clear').show();
      //     }
      // });
    }).on('click', '#activate_offer_restricted_countries, #hot-deal-ai-amount', function (event) {
      event.preventDefault();
      // Main.showPreloader($(this));
      Client.ajax.specialDealForNewCountries($(this));
    }).on('click', '#close-payment-form', function (event) {
      event.preventDefault();
      $('.popup--payment').removeClass('active');
      $('.popup--payment--form').html('');
    }).on('click', '.form-step__border', function (event) {
      $(this).find('input[name="post_task_budget_radio_buttons"]').prop('checked', true);
      Client.manageRadioBudgetTypes();
    });

    // .on('keydown', 'form.chat__send', function (event) {
    //     let special = event.enterKey || event.shiftKey;
    //     let key = event.charCode || event.keyCode;
    //
    //     if (special && key == 13 || special && key == 16) {
    //
    //     } else if (event.keyCode === 13 && event.shiftKey) {
    //         if ($('#send-message').length) {
    //             $("#send-message").click();
    //         }
    //     }
    // })
  },

  updateRelatedCategoriesData: function updateRelatedCategoriesData() {
    var relatedData = {};
    $('.related-categories--block').each(function () {
      var checkbox = $(this).find('.checkbox');
      var textarea = $(this).find('.form-element__textarea');
      var id = checkbox.attr('id').replace('related-item-', '');
      var isChecked = checkbox.is(':checked');
      var comment = textarea.val().trim();
      relatedData[id] = {
        "id": id,
        "check": isChecked ? 1 : 0,
        "comment": comment
      };
    });
    $('#related-item-data').val(JSON.stringify(relatedData));
    console.log(JSON.stringify(relatedData));
  },
  manageRadioBudgetTypes: function manageRadioBudgetTypes() {
    var radioValue = parseInt($('[name="post_task_budget_radio_buttons"]:checked').val());
    if (radioValue !== 2) {
      $('.amount-price-visible').hide();
      $('.amount-price-hide').show();
      $('.amount-price-hide').closest('.form-step__input--error').removeClass('form-step__input--error');
      setTimeout(function () {
        $('[name="client_budget"]').val(1);
      }, 500);
    } else {
      $('.amount-price-visible').show();
      $('.amount-price-hide').hide();
      $('[name="client_budget"]').val('');
      $('#platform_fees_taxes').text('-');
      $('#total_price').text('-');
    }
  },
  initRating: function initRating() {
    var rating = document.querySelector('.pop-up-tasks__rating');
    var ratingItem = document.querySelectorAll('.pop-up-tasks__stars');
    rating.onclick = function (e) {
      var target = e.target;
      if (target.classList.contains('pop-up-tasks__stars')) {
        target.classList.add('active', 'current-active');
        $('input[name="reviewRating"]').val(target.dataset.value);
        mouseOverActive(ratingItem);
      }
    };
    rating.onmouseover = function (e) {
      var target = e.target;
      if (target.classList.contains('pop-up-tasks__stars')) {
        removeClass(ratingItem, 'active');
        target.classList.add('active');
        mouseOverActive(ratingItem);
      }
    };
    document.querySelector('.pop-up-tasks__block').onmouseout = function (e) {
      if (!$(".pop-up-tasks__stars").hasClass("current-active")) {
        $('.pop-up-tasks__stars').removeClass('active');
      }
    };
    function removeClass(arr) {
      for (var i = 0, iLen = arr.length; i < iLen; i++) {
        for (var j = 1; j < arguments.length; j++) {
          ratingItem[i].classList.remove(arguments[j]);
        }
      }
    }
    function mouseOverActive(arr) {
      for (var i = 0, iLen = arr.length; i < iLen; i++) {
        if (arr[i].classList.contains('active')) {
          break;
        } else {
          arr[i].classList.add('active');
        }
      }
    }
  },
  calculateBudget: function calculateBudget(amount) {
    var hours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var infoBlockForSP = $('.price-input--info');
    var spEarningAmount = $('.sp_earning_amount');
    var spEarningCommission = $('#pending-cancellation-offer-amount');
    var platformFeesTaxesInput = $('#platform_fees_taxes');
    var totalPriceInput = $('#total_price');
    var platformFeesValue = '-';
    var totalValue = '-';
    if (!isNaN(amount) && parseInt(amount) > 0) {
      var _$$val2;
      amount = parseFloat(amount) * hours;
      var taskID = parseInt((_$$val2 = $('[name=client_task_id]').val()) !== null && _$$val2 !== void 0 ? _$$val2 : 0);
      var formData = new FormData();
      formData.append('method', 'getSpCommission');
      formData.append('taskID', taskID);
      formData.append('amount', amount);
      platformFeesValue = (amount > 150 ? (amount * SITE_CLIENT_COMMISSION).toFixed(2) : 8) * (1 + SITE_VAT_COMMISSION);
      totalValue = (amount + parseFloat(platformFeesValue)).toFixed(2);
      $.ajax({
        url: CLIENT_AJAX_URL,
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        success: function success(answer) {
          var SITE_SP_COMMISSION_DYNAMIC = parseFloat(answer.commission);
          // let spCalculations = 1 - SITE_SP_COMMISSION;
          var spCalculations = 1 - SITE_SP_COMMISSION_DYNAMIC;
          var spCommission = (amount * (spCalculations - SITE_SP_COMMISSION_DYNAMIC * SITE_VAT_COMMISSION)).toFixed(2);
          if (spCommission >= 1) {
            $('[name=make_offer_commission]').val(SITE_SP_COMMISSION_DYNAMIC);
            $('.submit-form').prop('disabled', false);
            spEarningAmount.text(spCommission);
            // console.log('amount ' + amount);
            spEarningCommission.text(spCommission);
            // spEarningCommission.text((amount - spCommission).toFixed(2) + '€');

            $('.offer-result-3').closest('.range--info').removeAttr('style');
            $('.offer-result-3').hide();
            infoBlockForSP.show();
            if (parseInt(answer.less)) {
              $('.offer-result-1').show();
              $('.offer-result-2').hide();
            } else {
              $('.offer-result-1').show();
              $('.offer-result-2').hide();
            }
          } else {
            infoBlockForSP.show();
            $('.offer-result-1').hide();
            $('.offer-result-2').hide();
            $('.offer-result-3').closest('.range--info').css({
              'padding': '13px',
              'display': 'flex'
            });
            $('.offer-result-3').show();
            $('.submit-form').prop('disabled', true);
          }
        }
      });
    } else {
      infoBlockForSP.hide();
    }
    if (platformFeesValue !== '-') {
      platformFeesTaxesInput.text(platformFeesValue.toFixed(2));
      totalPriceInput.text(totalValue);
    }
  },
  checkedSelect: function checkedSelect(thisItem) {
    var selectFirst = thisItem.closest('.form-step__item').find('.select-check-value');
    var selectSecond = thisItem.closest('.form-step__item').find('.select-check-value--two');
    var getValue = selectFirst.val() + selectSecond.val();
    if (getValue == 11 || getValue == 10 || getValue == 0 + 1) {
      thisItem.closest('.form-step__item').find('.show-block').removeClass('hidden');
      thisItem.closest('.form-step__item').find('.show-block select').prop('disabled', false);
    } else {
      thisItem.closest('.form-step__item').find('.show-block').addClass('hidden');
      thisItem.closest('.form-step__item').find('.show-block select').prop('disabled', true);
    }
  },
  setDateJson: function setDateJson() {
    var data = {};
    var blocks = document.querySelectorAll(".block-when-dates");
    blocks.forEach(function (item, index) {
      var date = item.querySelector(".block-when-date").value;
      var hourStart = item.querySelector(".block-when-hour-start").value;
      var hourFinish = item.querySelector(".block-when-hour-finish").value;
      data = _objectSpread(_objectSpread({}, data), {}, _defineProperty({}, index, {
        date: date,
        hourStart: hourStart,
        hourFinish: hourFinish
      }));
    });
    if ($('#when-1').is(':checked')) {
      $('.get-date-json').val('1');
    } else {
      $('.get-date-json').val(JSON.stringify(data));
    }
  },
  initDateTimePicker: function initDateTimePicker() {
    $('.block-when-dates').each(function () {
      Client.subInitDateTimePicker($(this));
    });
  },
  subInitDateTimePicker: function subInitDateTimePicker(block) {
    var dateID = block.find('.block-when-date').attr('id');
    var hourStartID = block.find('.block-when-hour-start').attr('id');
    var hourFinishID = block.find('.block-when-hour-finish').attr('id');
    var date = $("#".concat(dateID)).flatpickr({
      dateFormat: 'd.m.Y',
      enableTime: false,
      allowInput: false,
      minDate: Client.addMinutes(new Date(), 60),
      // minDate: Client.addMinutes(new Date(), 15),
      disableMobile: "true"
    });
    var start = $("#".concat(hourStartID)).flatpickr({
      dateFormat: 'H:i',
      noCalendar: true,
      enableTime: true,
      time_24hr: true,
      allowInput: false,
      minuteIncrement: 15,
      disableMobile: "true"

      // minDate: Client.addMinutes(new Date(), 60)
    });

    var finish = $("#".concat(hourFinishID)).flatpickr({
      dateFormat: 'H:i',
      noCalendar: true,
      enableTime: true,
      time_24hr: true,
      allowInput: false,
      minuteIncrement: 15,
      disableMobile: "true"

      // minDate: block.find('.block-when-hour-start').val()
    });

    // start.config.onClose = [() => {
    //     setTimeout(() =>  finish.open(), 1);
    //
    // }];

    date.config.onChange = [function (selDates) {
      // date.config.onClose = [(selDates) => {
      if (selDates[0]) {
        if (Client.checkDate(selDates[0])) {
          // start.set("minDate", Client.addMinutes(new Date(), 60));
          start.set("minDate", Client.addMinutes(Client.currentDate, 15));
        } else {
          start.set("minDate", selDates[0]);
        }
      }
    }];
    start.config.onChange = [function (selDates) {
      // start.config.onClose = [(selDates) => {
      // finish.set("minDate", '');
      if (selDates[0]) {
        finish.set("minDate", Client.addMinutes(selDates[0], 30));
      }
    }];

    // finish.config.onChange = [(selDates) => {
    // setTimeout(() =>  start.set("maxDate", selDates[0]), 1);
    // start.set("maxDate", selDates[0])
    // }]
  },

  checkDate: function checkDate(date) {
    var today = Client.currentDate;
    return date.getDate() == today.getDate() && date.getMonth() == today.getMonth() && date.getFullYear() == today.getFullYear();
  },
  addMinutes: function addMinutes(dateTime, minutes) {
    return new Date(dateTime.getTime() + minutes * 60000);
  },
  validateDateTime: function validateDateTime(button) {
    var state = [];
    $('.block-when-dates').each(function () {
      if ($(this).find('.block-when-date').val().length <= 0) {
        $(this).find('.block-when-date').parent().addClass('error');
      }
      if ($(this).find('.block-when-hour-start').val().length <= 0) {
        $(this).find('.block-when-hour-start').parent().addClass('error');
      }
      if ($(this).find('.block-when-hour-finish').val().length <= 0) {
        $(this).find('.block-when-hour-finish').parent().addClass('error');
      }
      if ($(this).find('.block-when-date').val().length <= 0 || $(this).find('.block-when-hour-start').val().length <= 0 || $(this).find('.block-when-hour-finish').val().length <= 0) {
        return state.push(false);
      }
    });
    Client.setDateJson(button);
    return !(state.length > 0);
  },
  validateRelatedServices: function validateRelatedServices(button) {
    var state = [];
    var selectedServices = 0;
    var block = $('.related-categories--block');
    block.each(function () {
      var input = $(this).find('input');
      var textarea = $(this).find('textarea');
      if (input.is(':checked')) {
        if (textarea.val().length <= 10) {
          $(this).find('.error').show();
          state.push(false);
        }
        ++selectedServices;
      }
    });
    Client.updateRelatedCategoriesData();
    var result = !(state.length > 0);
    if (!result) {
      Step.scrollToError('client_service_related_services');
    }
    if (block.length) {
      if (selectedServices < 2) {
        $('.related-categories-main-error').show();
        Step.scrollToError('client_service_related_services');
      } else {
        $('.related-categories-main-error').hide();
      }
      return result && selectedServices >= 2;
    }
    return result;
  },
  checkAddRemoveDateButtons: function checkAddRemoveDateButtons() {
    var rowWithDate = $('div.block-when-dates');
    rowWithDate.find(".form-step__add-date").hide();
    if (rowWithDate.length <= 4) {
      rowWithDate.last().find(".form-step__add-date").show();
    }
  },
  aiLine: function aiLine() {
    var baseLine = document.querySelector('.base-line');
    var overlayLine = document.querySelector('.overlay-line');
    if (baseLine && overlayLine) {
      var start = parseInt(baseLine.getAttribute('data-start'));
      var end = parseInt(baseLine.getAttribute('data-end'));
      var from = parseInt(overlayLine.getAttribute('data-from'));
      var to = parseInt(overlayLine.getAttribute('data-to'));
      var containerWidth = baseLine.parentElement.offsetWidth;
      baseLine.style.width = (end - start) / (end - start) * 100 + '%';
      overlayLine.style.width = (to - from) / (end - start) * 100 + '%';
      overlayLine.style.left = (from - start) / (end - start) * 100 + '%';

      // $(".ai--block__green .text span").typed({
      //     strings: [Client.spAiText],
      //     typeSpeed: 0,
      //     startDelay: 0,
      //     showCursor: true
      // });
    }
  },

  checkedSowBlock: function checkedSowBlock() {
    var radio = $('.make-offer-radio-btns');
    var fixedPriceBlock = $('.price-input__fixed-price');
    var perHourPriceBlock = $('.price-input__price-per-hour');
    var amount = 0;
    radio.change(function () {
      if ($('#fixed-price').is(':checked')) {
        fixedPriceBlock.css("display", "flex");
        fixedPriceBlock.find('input').prop('disabled', false);
        amount = $('.client_budget_1').val().trim();
      } else {
        fixedPriceBlock.hide();
        fixedPriceBlock.find('input').prop('disabled', true);
        amount = $('.client_budget_2').val().trim();
      }
      var hours = 1;
      if ($('#price-per-hour').is(':checked')) {
        hours = parseInt($('[name="make_offer_amount_per_hour"]').val());
      }
      if (amount) {
        Client.calculateBudget(parseFloat(amount), hours);
      } else {
        $('.offer-result-1').hide();
        $('.offer-result-2').hide();
        $('.offer-result-3').hide();
      }
    });
    radio.change(function () {
      if ($('#price-per-hour').is(':checked')) {
        perHourPriceBlock.css("display", "flex");
        perHourPriceBlock.find('input').prop('disabled', false);
        perHourPriceBlock.find('select').prop('disabled', false);
      } else {
        perHourPriceBlock.hide();
        perHourPriceBlock.find('input').prop('disabled', true);
        perHourPriceBlock.find('select').prop('disabled', true);
      }
    });
  },
  checkedBlockBookingMethod: function checkedBlockBookingMethod() {
    $('.form-step__border').click(function () {
      $('input[type="radio"]').prop('checked', false);
      $(this).find('input[type="radio"]').prop('checked', true);
    });
    $('.form-step__price').click(function () {
      $('input[type="radio"]').prop('checked', false);
      $(this).find('input[type="radio"]').prop('checked', true);
    });
  },
  showPopUp: function showPopUp() {
    $(".my-task__private-icon").hover(function () {
      $(this).closest('.my-task__checked').find('.pop-up-private').css('display', 'flex');
    }, function () {
      $(this).closest('.my-task__checked').find('.pop-up-private').css('display', 'none');
    });
    $(".my-task__public-icon").hover(function () {
      $(this).closest('.my-task__checked').find('.pop-up-public').css('display', 'flex');
    }, function () {
      $(this).closest('.my-task__checked').find('.pop-up-public').css('display', 'none');
    });
  },
  generateMapWithRoutesForTaskDetailsPage: function generateMapWithRoutesForTaskDetailsPage() {
    if ($('#task_map').length) {
      var type = $('#task_map').attr('data-type');
      var cachedData = sessionStorage.getItem('cachedData-' + $('#task_map').attr('data-id'));
      var pointStart = {
        lat: parseFloat($('#task_map').attr('data-lat')),
        lng: parseFloat($('#task_map').attr('data-lng'))
      };
      if (parseInt(type) === 1) {
        var pointFinish = {
          lat: parseFloat($('#task_map').attr('data-lat-to')),
          lng: parseFloat($('#task_map').attr('data-lng-to'))
        };
        var mapBounds = new google.maps.LatLngBounds(pointStart, pointFinish);
        var map = new google.maps.Map(document.getElementById('task_map'), {
          center: mapBounds.getCenter(),
          zoom: 10,
          mapId: 'fc147a215044ba81',
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          zoomControl: false,
          panControlOptions: {
            position: google.maps.ControlPosition.TOP_RIGHT
          },
          zoomControlOptions: {
            position: google.maps.ControlPosition.TOP_RIGHT
          }
        });
        var route = {
          origin: pointStart,
          destination: pointFinish,
          travelMode: 'DRIVING'
        };
        var directionsService = new google.maps.DirectionsService();
        var directionsRenderer = new google.maps.DirectionsRenderer();
        directionsRenderer.setMap(map);
        var checkOld = sessionStorage.getItem('cachedDataCheck-' + $('#task_map').attr('data-id'));
        var checkNew = $('#task_map').attr('data-lat') + $('#task_map').attr('data-lng') + $('#task_map').attr('data-lat-to') + $('#task_map').attr('data-lng-to');
        if (cachedData && checkNew === checkOld) {
          var data = JSON.parse(cachedData);
          console.log(data);
          directionsRenderer.setDirections(data);
          var directionsData = data.routes[0].legs[0];
          if (!directionsData) {
            return;
          }
          Client.setMapLabel(map, directionsData.distance.text, mapBounds.getCenter());
        } else {
          directionsService.route(route, function (response, status) {
            if (status !== 'OK') {
              return;
            } else {
              directionsRenderer.setDirections(response);
              var _directionsData = response.routes[0].legs[0];
              if (!_directionsData) {
                return;
              } else {
                Client.setMapLabel(map, _directionsData.distance.text, response.routes[0].bounds.getCenter());
                sessionStorage.setItem('cachedData-' + $('#task_map').attr('data-id'), JSON.stringify(response));
                sessionStorage.setItem('cachedDataCheck-' + $('#task_map').attr('data-lat'), checkNew);
              }
            }
          });
        }
      } else {
        console.log('Handyman');
        var _map = new google.maps.Map(document.getElementById('task_map'), {
          center: pointStart,
          zoom: 12,
          mapId: 'fc147a215044ba81',
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          zoomControl: false
        });
        var marker = new google.maps.Marker({
          position: pointStart,
          map: _map,
          title: ''
        });
      }
    }
  },
  setMapLabel: function setMapLabel(map, distanceText, routeCenter) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var distanceLabel, _yield$google$maps$im, AdvancedMarkerElement, marker;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            distanceLabel = document.createElement("div");
            distanceLabel.className = "business-distance-map-label";
            distanceLabel.textContent = distanceText;
            _context.next = 5;
            return google.maps.importLibrary("marker");
          case 5:
            _yield$google$maps$im = _context.sent;
            AdvancedMarkerElement = _yield$google$maps$im.AdvancedMarkerElement;
            marker = new AdvancedMarkerElement({
              map: map,
              position: routeCenter,
              content: distanceLabel
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  getUserCountry: function getUserCountry() {
    $.ajax({
      url: 'https://ipapi.co/json/',
      type: 'GET',
      dataType: 'json',
      success: function success(response) {
        Client.userCountryCode = response.country.toLowerCase();
      },
      error: function error(_error) {}
    });
  },
  ajax: {
    obj: {},
    url: CLIENT_AJAX_URL,
    send: function send(success, failure) {
      var _this = this;
      $.post(this.url, this.obj, function (answer) {
        _this.obj = {};
        answer.result && typeof success === 'function' ? success(answer) : !answer.result && typeof failure === 'function' ? failure(answer) : null;
      }, 'JSON');
    },
    checkSubscription: function checkSubscription(taskHash) {
      this.obj.method = 'checkSubscription';
      this.obj.taskHash = taskHash;
      this.send(function (answer) {
        if (answer.data.isTaskOpened) {
          Client.ajax.getOpenOffers(taskHash);
        } else {
          if (answer.data.plan == 0) {
            $('.choose-plan--popup').addClass('active');
            $('.choose-plan--popup').attr('data-hash', taskHash);
            $('.view-all-offers').text($('.view-all-offers').attr('data-text'));
          } else if (answer.data.plan == 1) {
            Client.ajax.openConfirmOpenOffersPopup(taskHash);
          } else {
            Client.ajax.getOpenOffers(taskHash);
          }
        }
      }, function (answer) {
        console.log('Error');
      });
    },
    openConfirmOpenOffersPopup: function openConfirmOpenOffersPopup(taskHash) {
      this.obj.method = 'openConfirmOpenOffersPopup';
      this.obj.taskHash = taskHash;
      this.send(function (answer) {
        $('.confirm-open-offers--popup').addClass('active');
        $('.confirm-open-offers--content').html(answer.html);
        $('.confirm-open-offers--btn').attr('data-hash', taskHash);
      }, function (answer) {
        console.log('Error');
      });
    },
    getOpenOffers: function getOpenOffers(taskHash) {
      this.obj.method = 'getOpenOffers';
      this.obj.taskHash = taskHash;
      this.send(function (answer) {
        Main.hidePreloader($('.view-all-offers'));
        $('.choose-plan').removeClass('active');
        $('body').append(answer.html);
      }, function (answer) {
        console.log('Error');
      });
    },
    openPaymentPlanBlockPopup: function openPaymentPlanBlockPopup($button, autoRenew, plan, pMethod, amount, count) {
      this.obj.method = 'getPaymentPlanDataPopup';
      this.obj.autoRenew = autoRenew;
      this.obj.plan = plan;
      this.obj.pMethod = pMethod;
      this.obj.amount = plan;
      this.obj.count = count;
      this.send(function (answer) {
        var plansBlock = $('#plans-payment-popup');
        plansBlock.html(answer.html);
        plansBlock.closest('.popup--payment').addClass('active');
        $('.choose-plan--popup').removeClass('active');
        Main.hidePreloader($button);
        // Step.scrollToElement(plansBlock);

        Payment.payButton = '#book-subscription-plan';
        Payment.init();
        ++Payment.initCounter;
      }, function (answer) {
        console.log('Error');
      });
    },
    closeFindTaskOptionPopup: function closeFindTaskOptionPopup() {
      this.obj.method = 'closeFindTaskOptionPopup';
      this.send(function (answer) {}, function (answer) {
        console.log('Error');
      });
    },
    saveFindTaskOptions: function saveFindTaskOptions(country, city, type, location, lat, lng, radius) {
      this.obj.method = 'saveFindTaskOptions';
      this.obj.country = country;
      this.obj.city = city;
      this.obj.type = type;
      this.obj.location = location;
      this.obj.lat = lat;
      this.obj.lng = lng;
      this.obj.radius = radius;
      this.send(function (answer) {
        Notify.successfulNotification($('#save-find-task-options').attr('data-text'));
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      }, function (answer) {
        console.log('Error');
      });
    },
    openOfferDetailsPopup: function openOfferDetailsPopup(hash) {
      this.obj.method = 'openOfferDetailsPopup';
      this.obj.hash = hash;
      this.send(function (answer) {
        $('.offer-details-popup').show();
        $('.offer-details-popup__container').html(answer.html);
        var swiper = new Swiper('.masters-works-container', {
          slidesPerView: 4,
          spaceBetween: 8,
          loop: true,
          // breakpoints: {
          //     640: {
          //         slidesPerView: 2,
          //     },
          //     992: {
          //         slidesPerView: 3,
          //     },
          // },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true,
            dynamicMainBullets: 1
          }
        });
        Fancybox.bind("[data-fancybox]", {});
      }, function (answer) {
        console.log('Error');
      });
    },
    chooseDirection: function chooseDirection() {
      this.obj.method = 'chooseDirection';
      this.obj.edit = Client.edit;
      this.obj.hash = Client.hash;
      this.obj.type = Client.type;
      this.obj.typeID = Client.typeID;
      this.obj.text = Client.text;
      this.obj.serviceID = Client.serviceID;
      this.send(function (answer) {
        $('#post-task-block').html(answer.html);
        Step.scrollToTop();
        Driver.files.list = [];
        Autocomplete.googleAutocompleteForClient.autocompleteField();
        Client.initDateTimePicker();
      }, function (answer) {
        console.log('Error');
      });
    },
    fetchFirstClientFormStep: function fetchFirstClientFormStep() {
      this.obj.method = 'fetchFirstClientFormStep';
      this.obj.edit = Client.edit;
      this.obj.hash = Client.hash;
      this.obj.type = Client.type;
      this.obj.typeID = Client.typeID;
      this.obj.serviceID = Client.serviceID;
      this.obj.text = Client.text;
      this.send(function (answer) {
        $('#post-task-block').html(answer.html);
        Main.showTips();
        Step.scrollToTop();
        Autocomplete.googleAutocompleteForClient.autocompleteField();
        Client.initDateTimePicker();
      }, function (answer) {
        console.log('Error');
      });
    },
    backToChooseDirectionPage: function backToChooseDirectionPage() {
      this.obj.method = 'backToChooseDirectionPage';
      this.obj.hash = Client.hash;
      this.obj.edit = Client.edit;
      this.send(function (answer) {
        $('#post-task-block').html(answer.html);
        Client.type = undefined;
        Client.typeID = undefined;
        Step.scrollToTop();
      }, function (answer) {
        console.log('Error');
      });
    },
    backToChooseServicePage: function backToChooseServicePage() {
      this.obj.method = 'backToChooseServicePage';
      this.obj.hash = Client.hash;
      this.obj.edit = Client.edit;
      this.obj.type = Client.type;
      this.obj.typeID = Client.typeID;
      this.obj.serviceID = Client.serviceID;
      this.obj.text = Client.text;
      this.send(function (answer) {
        $('#post-task-block').html(answer.html);
        Step.scrollToTop();
      }, function (answer) {
        console.log('Error');
      });
    },
    fetchBlockWhen: function fetchBlockWhen(variant) {
      this.obj.method = 'fetchBlockWhen';
      this.obj.edit = Client.edit;
      this.obj.hash = Client.hash;
      this.obj.variant = variant;
      this.send(function (answer) {
        $('#block-when-variants').html(answer.html);
        Client.initDateTimePicker();
      }, function (answer) {
        console.log('Error');
      });
    },
    rejectOffer: function rejectOffer(offerHash, reason) {
      this.obj.method = 'rejectOffer';
      this.obj.offerHash = offerHash;
      this.obj.reason = reason.length === 0 ? '' : reason;
      this.send(function () {
        $('#reject-offer-popup').hide();
        $(".offer-info-item[id=\"".concat(offerHash, "\"]")).remove();
        $('#reject-offer').attr('data-offer', '');
        if ($('.offer-info-item').length === 0) {
          location.reload();
        }
      }, function (answer) {
        $('.form-pop-up__error').show().text(answer.error);
        setTimeout(function () {
          $('.form-pop-up__error').hide().text('');
        }, 1500);
      });
    },
    withdrawOfferAsServiceProvider: function withdrawOfferAsServiceProvider(offerHash) {
      var reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.obj.method = 'withdrawOfferAsServiceProvider';
      this.obj.offerHash = offerHash;
      this.obj.reason = reason;
      this.send(function () {
        if ($('.my-task__item').length) {
          $(".my-task__item[data-offer-hash=\"".concat(offerHash, "\"]")).remove();
        } else {
          $(".card-new__item[data-offer-hash=\"".concat(offerHash, "\"]")).remove();
        }
        $('#withdraw-edit-popup').hide();
        $('#reject-offer').attr('data-offer', '');
        var counterBlock = $('.applied-tasks-tab').find('span').find('span');
        counterBlock.text(parseInt(counterBlock.text()) - 1);
        if ($("div.offers__item").length === 0) {
          $('.empty').show();
        }
        location.reload();
      }, function (answer) {
        $('.form-pop-up__error').show().text(answer.error);
        setTimeout(function () {
          $('.form-pop-up__error').hide().text('');
        }, 1500);
      });
    },
    cancelOfferAsServiceProvider: function cancelOfferAsServiceProvider(button) {
      this.obj.method = 'cancelOfferAsServiceProvider';
      this.obj.data = button.closest('form').serializeArray();
      this.obj.hash = Client.hash;
      this.send(function () {
        Main.hidePreloader(button);
        $('#cancel-offer-as-service-provider').hide();
        Client.ajax.fetchOfferCard(Client.hash, Client.type);
      }, function (answer) {
        $.each(answer.errors, function (name, value) {
          Step.showErrors(name, value);
        });
        Main.hidePreloader(button);
      });
    },
    cancelOfferAsClient: function cancelOfferAsClient(button) {
      this.obj.method = 'cancelOfferAsClient';
      this.obj.data = button.closest('form').serializeArray();
      this.obj.hash = Client.hash;
      this.send(function () {
        Main.hidePreloader(button);
        $('#cancel-offer-as-client').hide();
        Client.ajax.fetchOfferCard(Client.hash, Client.type);
      }, function (answer) {
        $.each(answer.errors, function (name, value) {
          Step.showErrors(name, value);
        });
        Main.hidePreloader(button);
      });
    },
    approveOffer: function approveOffer(button, hash, type) {
      this.obj.method = 'approveOffer';
      this.obj.hash = hash;
      this.obj.dataID = $('[name="offer_date"]:checked').val();
      this.send(function () {
        $('#approve-popup').hide();
        Client.ajax.fetchOfferCard(hash, type);
      }, function (answer) {
        if (!answer.phoneVerification) VerifyPhone.openFirstStep();
        Main.hidePreloader(button);
      });
    },
    markCompletedAsClient: function markCompletedAsClient(button, hash, type) {
      this.obj.method = 'markCompletedAsClient';
      this.obj.hash = hash;
      this.send(function () {
        Client.ajax.openReview(hash);
        Client.ajax.fetchOfferCard(hash, type);
      }, function () {
        console.log('Error');
        Main.hidePreloader(button);
      });
    },
    markCompletedAsServiceProvider: function markCompletedAsServiceProvider(button, hash, type) {
      this.obj.method = 'markCompletedAsServiceProvider';
      this.obj.hash = hash;
      this.send(function () {
        // Client.ajax.openReview(hash);
        Client.ajax.fetchOfferCard(hash, type);
      }, function () {
        console.log('Error');
        Main.hidePreloader(button);
      });
    },
    openReview: function openReview(hash) {
      this.obj.method = 'openReview';
      this.obj.hash = hash;
      this.send(function (answer) {
        var reviewPopup = $('#review-popup');
        reviewPopup.show();
        reviewPopup.find('.pop-up-tasks__container').html(answer.html);
        Client.initRating();
      }, function () {
        console.log('Error');
      });
    },
    openExtendOfferPopup: function openExtendOfferPopup(button, hash) {
      this.obj.method = 'openExtendOfferPopup';
      this.obj.hash = hash;
      this.send(function (answer) {
        var extendOfferPopup = $('#extend-offer-popup');
        extendOfferPopup.show();
        extendOfferPopup.find('.pop-up-service__container').html(answer.html);
        Main.hidePreloader(button);
      }, function () {
        Main.hidePreloader(button);
        console.log('Error');
      });
    },
    rejectExtendOffer: function rejectExtendOffer(button, hash) {
      this.obj.method = 'rejectExtendOffer';
      this.obj.hash = hash;
      this.send(function (answer) {
        var offerHash = button.attr('data-offer-hash');
        Client.ajax.openExtendOfferPopup(button, offerHash);
        Main.hidePreloader(button);
        Client.ajax.fetchOfferCard(offerHash, $(".my-task__item[data-offer-hash=\"".concat(offerHash, "\"]")).attr('data-type'));
      }, function () {
        Main.hidePreloader(button);
        console.log('Error');
      });
    },
    fetchOfferCard: function fetchOfferCard(hash, type) {
      this.obj.method = 'fetchOfferCard';
      this.obj.hash = hash;
      this.obj.type = type;
      this.obj.designType = $('.my-task__item').length ? 0 : 1;
      this.send(function (answer) {
        if ($('.my-task__item').length) {
          $(".my-task__item[data-offer-hash=\"".concat(hash, "\"]")).html(answer.html);
        } else {
          $(".card-new__item[data-offer-hash=\"".concat(hash, "\"]")).html(answer.html);
        }
      }, function () {
        console.log('Error');
      });
    },
    showRecommendationPopupWithSpProfile: function showRecommendationPopupWithSpProfile(userID) {
      this.obj.method = 'showRecommendationPopupWithSpProfile';
      this.obj.userID = userID;
      this.send(function (answer) {
        $('body').append(answer.html);
      }, function () {
        console.log('Error');
      });
    },
    fetchApproveOfferPopup: function fetchApproveOfferPopup(hash, type) {
      this.obj.method = 'fetchApproveOfferPopup';
      this.obj.hash = hash;
      this.obj.type = type;
      this.send(function (answer) {
        $('#approve-popup-body').html(answer.html);
      }, function () {
        console.log('Error');
      });
    },
    addAdditionalDateTimeBlock: function addAdditionalDateTimeBlock() {
      this.obj.method = 'addAdditionalDateTimeBlock';
      this.obj.id = parseInt($(".block-when-dates").length) + Math.round(Math.random() * 445) + 88763;
      // this.obj.id = parseInt($(".block-when-dates").length) + 1;

      this.send(function (answer) {
        $('#block-when-variants').append(answer.html);
        if ($(".block-when-dates").length >= 4) {
          $(".form-step__add-date").hide();
        }
        Client.checkAddRemoveDateButtons();
        Client.subInitDateTimePicker($('div.block-when-dates').last());
        $('div.block-when-dates').first().find('.form-step__remove-date').show();
      }, function () {
        console.log('Error');
      });
    },
    postTask: function postTask($submitBtn) {
      this.obj.method = 'postTask';
      this.obj.edit = Client.edit;
      this.obj.hash = Client.hash;
      this.obj.typeID = parseInt($submitBtn.closest('form').data('type'));
      this.obj.data = $submitBtn.closest('form').serializeArray();
      this.send(function (answer) {
        Step.taskID = answer.serviceID;
        Step.callbackUrl = answer.callbackUrl;
        Step.postTaskAsGuest = answer.isGuest;
        Step.taskPosted = true;
        Main.showPreloader($submitBtn);
        Step.files.uploadAllFiles();
      }, function (answer) {
        $.each(answer.errors, function (k, v) {
          $submitBtn.closest('form').find("[name=\"".concat(k, "\"]")).closest('div').find('.error').show().html(v);
        });
        Main.hidePreloader($submitBtn);
        if (answer.savingError) Notify.dangerNotification(answer.savingError);
        if (!answer.phoneVerification) VerifyPhone.openFirstStep();
      });
    },
    generateAiApproxBudget: function generateAiApproxBudget($submitBtn) {
      this.obj.method = 'generateAiApproxBudget';
      this.obj.taskHash = Client.hash;
      this.obj.typeID = parseInt($submitBtn.closest('form').data('type'));
      this.obj.data = $submitBtn.closest('form').serializeArray();
      this.send(function (answer) {
        if (answer.data.answer.length > 0) {
          $('.ai--block__green').css('display', 'flex');
          $('.ai--block__green .text span').html('');

          // $(".ai--block__green .text span").typed({
          //     strings: [answer.data.answer],
          //     typeSpeed: 0,
          //     startDelay: 0,
          //     showCursor: false
          // });

          if (Client.typedInstance) Client.typedInstance.destroy();
          Client.typedInstance = new Typed('.ai--block__green .text span', {
            strings: [answer.data.answer],
            typeSpeed: 0,
            startDelay: 0,
            showCursor: false,
            onComplete: function onComplete() {
              // setTimeout(function () {
              //     button.find('span').text(button.attr('data-text'));
              // }, 765);
            }
          });
          Client.aiSuggestedPrice = answer.data.min;
          if (Client.aiSuggestedPrice > 0 && parseInt(answer.showSpecialDealBlock) === 1) {
            $('.hot-deal-container').show();
            $('input[name="post_task_budget_radio_buttons"][value="1"]').prop('checked', true);
            $('#hot-deal-ai-amount').text(Client.aiSuggestedPrice + ' €');
            $('.counter').eq(0).text(1);
            $('.counter').eq(1).text(2);
            $('.counter').eq(2).text(3);
          } else {
            $('.hot-deal-container').hide();
            $('input[name="post_task_budget_radio_buttons"][value="2"]').prop('checked', true);
            $('.counter').eq(1).text(1);
            $('.counter').eq(2).text(2);
          }
        } else {
          $('.ai--block__green').hide();
        }
        Client.manageRadioBudgetTypes();
      }, function (answer) {});
    },
    specialDealForNewCountries: function specialDealForNewCountries(button) {
      this.obj.method = 'specialDealForNewCountries';
      this.obj.amount = Client.aiSuggestedPrice;
      this.obj.paymentMethod = Client.specialDealMethod;
      this.obj.country = Client.specialDealCountry;
      this.obj.taskHash = Client.hash.length > 0 ? Client.hash : Client.specialDealTaskHash;
      this.obj.offerHash = Client.specialDealOfferHash;
      this.obj.data = button.closest('form').serializeArray();
      this.send(function (answer) {
        Client.specialDealTaskHash = answer.taskHash;
        Client.hash = answer.taskHash;
        Client.edit = 1;
        $('.popup--payment').addClass('active');
        $('.popup--payment--form').html(answer.html);
        Payment.type = answer.paymentData.type;
        Payment.amount = answer.paymentData.amount;
        Payment.bonus = answer.paymentData.bonusApplied;
        Payment.payableNow = answer.paymentData.payableNow;
        Payment.payoutOption = 1;
        Payment.serviceType = 2;
        Payment.serviceID = answer.paymentData.hash;
        Payment.stripePaymentIntent = answer.paymentData.paymentIntent;
        Payment.stripePublishableKey = answer.paymentData.stripePublishableKey;
        Payment.callbackUrlForSofort = answer.paymentData.callbackUrlForSofort;
        Payment.payButton = '#book-task-special-offer';
        ++Payment.initCounter;
        Payment.init();
        // Main.hidePreloader(button);
      }, function (answer) {
        Notify.dangerNotification(answer.error);
        // Main.hidePreloader(button);
      });
    },

    generateAiSpComment: function generateAiSpComment(button, textarea, taskID) {
      this.obj.method = 'generateAiSpComment';
      this.obj.taskID = taskID;
      this.send(function (answer) {
        if (answer.text.length > 0) {
          // if (Client.typedInstance) Client.typedInstance.destroy();

          textarea.val('');
          textarea.val(answer.text);
          Main.hidePreloader(button);
          setTimeout(function () {
            button.find('span').text(button.attr('data-text'));
            $('.booking-service__clear').show();
          }, 750);

          // Client.typedInstance = new Typed('#make_offer_message', {
          //     strings: [answer.text],
          //     typeSpeed: 0,
          //     startDelay: 0,
          //     showCursor: false,
          //     onComplete: function () {
          //         $('.booking-service__clear').show();
          //         Main.hidePreloader(button);
          //         setTimeout(function () {
          //         Main.hidePreloader(button);
          //             button.find('span').text(button.attr('data-text'));
          // $('#make_offer_message').val(answer.text);
          // }, 765);
          // }
          // });
        } else {
          // button.hide();
          Main.hidePreloader(button);
        }
      }, function (answer) {
        Main.hidePreloader(button);
        setTimeout(function () {
          button.find('span').text(button.attr('data-text'));
        }, 765);
      });
    },
    bookService: function bookService($submitBtn) {
      this.obj.method = 'bookService';
      this.obj.edit = Client.edit;
      this.obj.hash = Client.hash;
      this.obj.serviceHash = Client.serviceHash;
      this.obj.typeID = parseInt($submitBtn.closest('form').data('type'));
      this.obj.data = $submitBtn.closest('form').serializeArray();
      this.obj.helpers = $('select.booking-helper-select option[value="1"]:selected').length;
      this.send(function (answer) {
        Step.taskID = answer.serviceID;
        Step.callbackUrl = answer.callbackUrl;
        Step.files.upload();
      }, function (answer) {
        $.each(answer.errors, function (k, v) {
          $submitBtn.closest('form').find("[name=\"".concat(k, "\"]")).closest('div').find('.error').show().html(v);
        });
        Main.hidePreloader($submitBtn);
        if (answer.savingError) Notify.dangerNotification(answer.savingError);
        if (!answer.phoneVerification) VerifyPhone.openFirstStep();
      });
    },
    changeBookingHours: function changeBookingHours(hours) {
      this.obj.method = 'changeBookingHours';
      this.obj.hash = Client.hash;
      this.obj.hours = hours;
      this.obj.forSP = parseInt($('[name="as_sp"]').val());
      this.send(function (answer) {
        $('#service_provider_fees').text(answer.serviceProviderFees);
        $('#platform_fees').text(answer.platformFeesForShow);
        if (answer.platformVat > 0) {
          $('#platform_vat').closest('.booking-service__item').show();
          $('#platform_vat').text(answer.platformVat);
        } else {
          $('#platform_vat').closest('.booking-service__item').hide();
        }
        $('#total_price').text(answer.totalPrice);
      }, function () {
        console.log('Error');
      });
    },
    changeBookingAmount: function changeBookingAmount(amount) {
      this.obj.method = 'changeBookingAmount';
      this.obj.hash = Client.hash;
      this.obj.amount = amount;
      this.obj.forSP = parseInt($('[name="as_sp"]').val());
      this.send(function (answer) {
        $('#service_provider_fees').text(answer.serviceProviderFees);
        $('.service_provider_fees').val(answer.serviceProviderFees);
        $('#platform_fees').text(answer.platformFeesForShow);
        if (answer.platformVat > 0) {
          $('#platform_vat').closest('.booking-service__item').show();
          $('#platform_vat').text(answer.platformVat);
        } else {
          $('#platform_vat').closest('.booking-service__item').hide();
        }
        $('#total_price').text(answer.totalPrice);
      }, function () {
        console.log('Error');
      });
    },
    renderBookingForm: function renderBookingForm(hash, type) {
      this.obj.method = 'renderBookingForm';
      this.obj.hash = hash;
      this.obj.type = type;
      this.send(function (answer) {
        $('.step-new').html(answer.html);
        Autocomplete.googleAutocompleteForClient.autocompleteField();
        Step.collectionDataForCalculatorOnTips($('.form-step__step').first().find('.form-step__next').attr('data-step'));
      }, function () {
        console.log('Error');
      });
    },
    deleteTask: function deleteTask(hash) {
      var cancel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      this.obj.method = 'deleteTask';
      this.obj.reason = reason;
      this.obj.hash = hash;
      this.send(function () {
        $('a#' + hash).remove();
        if (cancel) {
          $('#edit-cancel-task-popup').hide();
          $('#cancel-task').attr('data-task', '');
        } else {
          $('#delete-task-popup').hide();
          $('#delete-task').attr('data-task', '');
        }
        setTimeout(function () {
          window.location.reload();
        }, 150);
      }, function () {
        console.log('Error');
      });
    },
    addPublicTaskStatus: function addPublicTaskStatus(hash) {
      this.obj.method = 'addPublicTaskStatus';
      this.obj.hash = hash;
      this.send(function () {}, function () {
        console.log('Error');
      });
    },
    addPrivateTaskStatus: function addPrivateTaskStatus(hash) {
      this.obj.method = 'addPrivateTaskStatus';
      this.obj.hash = hash;
      this.send(function () {}, function () {
        console.log('Error');
      });
    },
    downloadOfferDetails: function downloadOfferDetails(button, hash) {
      this.obj.method = 'downloadOfferDetails';
      this.obj.hash = hash;
      this.send(function (answer) {
        window.open(answer.link, '_blank');
        Main.hidePreloader(button);
      }, function (answer) {
        if (answer.needClientInfo) {
          $('.download-offer-popup').find('.submit-form').attr('data-hash', hash);
          $('.download-offer-popup').addClass('active');
        }
        Main.hidePreloader(button);
      });
    }
  }
};